"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionTypeEnum = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `PAYMENT` - PAYMENT
 * * `PAYOUT` - PAYOUT
 */
var TransactionTypeEnum;
(function (TransactionTypeEnum) {
    TransactionTypeEnum["PAYMENT"] = "PAYMENT";
    TransactionTypeEnum["PAYOUT"] = "PAYOUT";
})(TransactionTypeEnum = exports.TransactionTypeEnum || (exports.TransactionTypeEnum = {}));
